import { combineReducers } from 'redux';
import appStatus from './app_status_reducer';
import authenticated from './authenticated_reducer';
import schedules from './schedules_reducer';
import participants from './participants_reducer';
import meetings from './meetings_reducer';
import meetingLayers from './meeting_layers_reducer';
import meetingLabels from './meeting_labels_reducer';
import studentCohortFilters from './student_cohort_filters_reducer';
import scheduledMeetings from './scheduled_meetings_reducer';
import controls from './schedule_controls_reducer';
import viewer from './schedule_viewer_reducer';
import modal from './modal_reducer';
import errors from './errors_reducer';

export default combineReducers({
	appStatus: appStatus,
	authenticated: authenticated,
	schedules: schedules,
	teachers: participants('teacher'),
	cohorts: participants('cohort'),
	meetings: meetings,
	meetingLayers: meetingLayers,
	meetingLabels: meetingLabels,
	studentCohortFilters: studentCohortFilters,
	scheduledMeetings: scheduledMeetings,
	controls: controls,
	viewer: viewer,
	modal: modal,
	errors: errors
});


/** WEBPACK FOOTER **
 ** ./src/js/reducers/index.js
 **/